import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Controller } from 'react-hook-form';
import { mergeProps } from '../../utils/react.js';
import { FormField } from '../FormField/FormField.js';
import { getError, mapProps } from './formUtils.js';
import { useReactHookForm } from './useReactHookForm.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["defaultValues", "fields", "inline", "onChange", "onSubmit", "reValidateMode", "validateMode"],
  _excluded2 = ["as"],
  _excluded3 = ["control", "validation"];
var defaultElement = "input";
function Component(props, ref) {
  var defaultValues = props.defaultValues,
    fields = props.fields,
    inline = props.inline,
    onChange = props.onChange,
    onSubmit = props.onSubmit,
    _props$reValidateMode = props.reValidateMode,
    reValidateMode = _props$reValidateMode === void 0 ? "onBlur" : _props$reValidateMode,
    _props$validateMode = props.validateMode,
    validateMode = _props$validateMode === void 0 ? "onSubmit" : _props$validateMode,
    rest = _objectWithoutProperties(props, _excluded);
  var _useReactHookForm = useReactHookForm({
      defaultValues: defaultValues,
      mode: validateMode,
      reValidateMode: reValidateMode,
      onChange: onChange
    }, ref),
    control = _useReactHookForm.control,
    formState = _useReactHookForm.formState,
    handleSubmit = _useReactHookForm.handleSubmit;
  var fieldComponents = [];
  var _loop = function _loop(name) {
    if (Object.prototype.hasOwnProperty.call(fields, name)) {
      var _fields$name = fields[name],
        _fields$name$control = _fields$name.control,
        _fields$name$control$ = _fields$name$control.as,
        ControllerInput = _fields$name$control$ === void 0 ? defaultElement : _fields$name$control$,
        inputProps = _objectWithoutProperties(_fields$name$control, _excluded2),
        validation = _fields$name.validation,
        fieldProps = _objectWithoutProperties(_fields$name, _excluded3);
      var error = getError(formState, name);
      fieldComponents.push( /*#__PURE__*/jsx(FormField, _objectSpread(_objectSpread({
        error: error,
        required: !!(validation !== null && validation !== void 0 && validation.required),
        inline: inline
      }, fieldProps), {}, {
        children: function children(controlId) {
          return /*#__PURE__*/jsx(Controller, {
            control: control,
            name: name,
            rules: validation,
            render: function render(_ref) {
              var field = _ref.field;
              return /*#__PURE__*/jsx(ControllerInput, _objectSpread(_objectSpread({
                id: controlId
              }, mergeProps(inputProps, mapProps(field))), {}, {
                error: !!error
              }));
            }
          });
        }
      }), name));
    }
  };
  for (var name in fields) {
    _loop(name);
  }
  return /*#__PURE__*/jsx("form", _objectSpread(_objectSpread({}, rest), {}, {
    onSubmit: onSubmit && handleSubmit(onSubmit),
    ref: ref,
    children: fieldComponents
  }));
}
Component.displayName = "Form";
var Form = /*#__PURE__*/React.forwardRef(Component);

export { Form };
